import { Component, Input } from '@angular/core';
import { CustomTableTypeChecker } from '../../../../../shared/classes/custom-table-type-checker';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { DataColumnType, DEFAULT_DATE_FORMAT, IFooterColums } from '../../../../../shared';

@Component({
  selector: 'tr[tableFooter]',
  standalone: true,
  imports: [CommonModule, TableModule, TranslateModule, TooltipModule],
  templateUrl: './table-footer.component.html',
  styleUrl: './table-footer.component.scss'
})
export class TableFooterComponent  {
  @Input() columns !: (IFooterColums)[];
  @Input() rowData !: any;
  tabletypeChecker = CustomTableTypeChecker;

  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  readonly DataColumnType = DataColumnType;
}
